import Amount from 'ni-ui/Amount';
import { withRegion } from '../../hoc';

const AmountWithRegion = withRegion(Amount);

export default AmountWithRegion;
